import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3787066"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "authorized-container"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "content" }

import { withDefaults, computed } from 'vue';
import { useStore } from 'vuex';
import BaseLogin from '@/components/BaseLogin.vue';
import BaseMenu from '@/components/layout/Menu/BaseMenu.vue';
import BasePending from '@/components/layout/BasePending.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    title: { default: undefined },
    isWithMenu: { type: Boolean, default: true }
  },
  setup(__props: any) {

const { getters } = useStore();
const isLoggedIn = computed<boolean>(() => getters['auth/isLoggedIn']);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isLoggedIn))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.isWithMenu)
            ? (_openBlock(), _createBlock(BaseMenu, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (__props.title)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(__props.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(BaseLogin, { key: 1 })),
    _createVNode(BasePending)
  ], 64))
}
}

})